import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { QuizConfigModal } from './QuizConfigModal';

import { useQuizForm } from '@/hooks';
import { useProfile } from '@/store';

interface Props {
  isFromBaseContent?: boolean;
}

export const CreateQuiz: React.FC<Props> = ({ isFromBaseContent }) => {
  const {
    roleCheck: { isInspector }
  } = useProfile();
  const { setConfigOpen } = useQuizForm();

  const { t } = useTranslation('ManagerQuizzesTranslations');

  if (isInspector) return null;

  return (
    <>
      <Button type="primary" onClick={() => setConfigOpen(true)}>
        {t('CREATE_QUIZ')}
      </Button>
      <QuizConfigModal isFromBaseContent={isFromBaseContent} />
    </>
  );
};
